/* Eclipse Sample Sales — chantier 2 (city-tabs)
 * Scanne `[data-eclipse-city]` au DOMContentLoaded, genere les tabs et bigwords,
 * gere l'activation par click + deep-link `#<handle>` + smooth scroll
 * horizontal du bigwords container pour centrer le mot actif (legacy parity).
 */
(function () {
  'use strict';

  function scanCities() {
    var nodes = document.querySelectorAll('[data-eclipse-city]');
    var cities = [];
    nodes.forEach(function (node) {
      var handle = node.getAttribute('data-eclipse-city');
      var name = node.getAttribute('data-eclipse-city-name') || handle;
      var section = node.closest('.shopify-section') || node.parentElement;
      if (!handle || !section) return;
      cities.push({
        handle: handle,
        name: name,
        section: section,
        anchorId: handle
      });
    });
    return cities;
  }

  function renderTabs(container, cities) {
    var bar = container.querySelector('.ec-city-tabs__bar');
    if (!bar) return;
    bar.innerHTML = '';
    cities.forEach(function (city, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ec-city-tabs__tab';
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      btn.setAttribute('data-eclipse-tab', city.handle);
      btn.textContent = city.name;
      if (i === 0) btn.classList.add('is-active');
      bar.appendChild(btn);
    });
  }

  function renderBigwords(container, cities) {
    var wrap = container.querySelector('.ec-city-tabs__bigwords');
    if (!wrap) return;
    wrap.innerHTML = '';
    cities.forEach(function (city, i) {
      var span = document.createElement('span');
      span.className = 'ec-city-tabs__bigword';
      span.setAttribute('data-eclipse-bigword', city.handle);
      span.textContent = city.name;
      if (i === 0) span.classList.add('is-active');
      wrap.appendChild(span);
    });
  }

  function smoothHorizontalScroll(container, target) {
    var startX = container.scrollLeft;
    var distance = target - startX;
    var duration = 400;
    var startTime = null;
    function step(now) {
      if (startTime === null) startTime = now;
      var t = Math.min(1, (now - startTime) / duration);
      var eased = 0.5 - Math.cos(t * Math.PI) / 2;
      container.scrollLeft = startX + distance * eased;
      if (t < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function centerActiveBigword(container, handle) {
    var wrap = container.querySelector('.ec-city-tabs__bigwords');
    if (!wrap) return;
    var active = wrap.querySelector('[data-eclipse-bigword="' + handle + '"]');
    if (!active) return;
    var wordCenter = active.offsetLeft + active.offsetWidth / 2;
    var containerCenter = wrap.scrollLeft + wrap.offsetWidth / 2;
    var delta = wordCenter - containerCenter;
    if (Math.abs(delta) > 10) {
      smoothHorizontalScroll(wrap, wrap.scrollLeft + delta);
    }
  }

  function activate(container, cities, handle, opts) {
    opts = opts || {};
    var match = cities.filter(function (c) { return c.handle === handle; })[0];
    if (!match) return;

    cities.forEach(function (c) {
      var on = c.handle === handle;
      c.section.classList.toggle('is-active-city', on);
      c.section.classList.toggle('is-inactive-city', !on);
      if (on) c.section.removeAttribute('hidden');
      else c.section.setAttribute('hidden', '');
    });

    container.querySelectorAll('[data-eclipse-tab]').forEach(function (tab) {
      var on = tab.getAttribute('data-eclipse-tab') === handle;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    container.querySelectorAll('[data-eclipse-bigword]').forEach(function (word) {
      var on = word.getAttribute('data-eclipse-bigword') === handle;
      word.classList.toggle('is-active', on);
    });

    centerActiveBigword(container, handle);

    if (opts.updateHash !== false) {
      try {
        history.replaceState(null, '', '#' + match.anchorId);
      } catch (e) { /* SSR / sandbox safety */ }
    }
  }

  function getInitialHandle(cities) {
    var hash = (window.location.hash || '').replace(/^#/, '');
    if (hash) {
      var byAnchor = cities.filter(function (c) { return c.anchorId === hash; })[0];
      if (byAnchor) return byAnchor.handle;
      var byHandle = cities.filter(function (c) { return c.handle === hash; })[0];
      if (byHandle) return byHandle.handle;
    }
    return cities[0] ? cities[0].handle : null;
  }

  function bindBigwordsDragAndWheel(container) {
    var wrap = container.querySelector('.ec-city-tabs__bigwords');
    if (!wrap) return;

    var isDown = false;
    var didDrag = false;
    var startX = 0;
    var startScrollLeft = 0;
    var DRAG_THRESHOLD = 5;

    wrap.addEventListener('mousedown', function (e) {
      isDown = true;
      didDrag = false;
      startX = e.pageX;
      startScrollLeft = wrap.scrollLeft;
    });

    wrap.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      var dx = e.pageX - startX;
      if (Math.abs(dx) > DRAG_THRESHOLD) {
        didDrag = true;
        wrap.classList.add('is-dragging');
      }
      if (didDrag) {
        e.preventDefault();
        wrap.scrollLeft = startScrollLeft - dx;
      }
    });

    function endDrag() {
      isDown = false;
      wrap.classList.remove('is-dragging');
    }
    wrap.addEventListener('mouseup', endDrag);
    wrap.addEventListener('mouseleave', endDrag);

    wrap.addEventListener('click', function (e) {
      if (didDrag) {
        e.stopPropagation();
        e.preventDefault();
        didDrag = false;
      }
    }, true);

    wrap.addEventListener('wheel', function (e) {
      var maxScroll = wrap.scrollWidth - wrap.clientWidth;
      if (maxScroll <= 0) return;

      var absX = Math.abs(e.deltaX);
      var absY = Math.abs(e.deltaY);
      var delta = absX > absY ? e.deltaX : e.deltaY;
      if (delta === 0) return;

      if (e.deltaMode === 1) delta *= 16;
      else if (e.deltaMode === 2) delta *= wrap.clientWidth;

      var atStart = wrap.scrollLeft <= 0 && delta < 0;
      var atEnd = wrap.scrollLeft >= maxScroll - 1 && delta > 0;
      if (atStart || atEnd) return;

      e.preventDefault();
      wrap.scrollLeft += delta;
    }, { passive: false });
  }

  function bindEvents(container, cities) {
    container.querySelectorAll('[data-eclipse-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(container, cities, tab.getAttribute('data-eclipse-tab'));
      });
    });
    container.querySelectorAll('[data-eclipse-bigword]').forEach(function (word) {
      word.addEventListener('click', function () {
        activate(container, cities, word.getAttribute('data-eclipse-bigword'));
      });
    });
    bindBigwordsDragAndWheel(container);
    window.addEventListener('hashchange', function () {
      var hash = (window.location.hash || '').replace(/^#/, '');
      var match = cities.filter(function (c) {
        return c.anchorId === hash || c.handle === hash;
      })[0];
      if (match) activate(container, cities, match.handle, { updateHash: false });
    });
  }

  function initContainer(container) {
    if (container.dataset.eclipseTabsInit === '1') return;
    container.dataset.eclipseTabsInit = '1';

    var cities = scanCities();
    if (cities.length < 2) {
      container.style.display = 'none';
      return;
    }

    renderTabs(container, cities);
    renderBigwords(container, cities);

    var initial = getInitialHandle(cities);
    if (initial) {
      activate(container, cities, initial, { updateHash: false });
    }

    bindEvents(container, cities);
  }

  function initAll() {
    document.querySelectorAll('[data-eclipse-city-tabs]').forEach(initContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-eclipse-city-tabs]')) {
      initAll();
    }
    if (e.target && e.target.matches && e.target.matches('[data-eclipse-city]')) {
      document.querySelectorAll('[data-eclipse-city-tabs]').forEach(function (c) {
        delete c.dataset.eclipseTabsInit;
      });
      initAll();
    }
  });
})();
